module.exports = new __parcel__URL__("insights.tpl.9da6e5db.svg").toString();